import React, { Component } from 'react'
import _ from 'lodash'
import NoImagePlaceholder from '../images/missing_image_large.png'

class FallbackImage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      load_error: false
    }
  }

  handleImgLoadError = (e) => {
    this.setState({ load_error: true })
  }

  render() {
    const image_placeholder = <img
      className={this.props.fallback_className}
      alt=''
      src={NoImagePlaceholder}
    />

    return this.state.load_error || _.isEmpty(this.props.src)
      ? image_placeholder
      : <img
        className={this.props.className}
        alt={this.props.alt}
        src={this.props.src}
        onError={this.handleImgLoadError}
      />
  }
}

export default FallbackImage



// WEBPACK FOOTER //
// ./src/components/FallbackImage.js